<template>
	<div class="mobile-filter-modal">
		<div class="popup">
			<div class="content">
				<div class="title">
					<h4 v-html="labels.filterAlt"></h4>
					<a class="cancel" @click="closeFilter"><i class="far fa-lg fa-times"></i></a>
				</div>

				<slot></slot>
			</div>
			<div class="fixed actions">
				<button class="confirm" v-html="labels.applyPlural" @click="applyFilters"></button>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				//
			}
		},

		methods: {
			closeFilter() {
				this.$emit('closeFilter');
			},

			applyFilters() {
				this.$emit('applyFilters');
			}
		}
	}
</script>
